<template>
  <v-app>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <v-container fluid>
            <v-card-title>
              <v-btn
                @click="create = !create"
                class="btn-add-with-text"
                v-status="'history_create'"
              >
                <v-icon>mdi-plus</v-icon>
                {{ $t("UserHistory.add_history") }}
              </v-btn>
              <v-spacer />
              {{ $t("UserHistory.title") }}
              <v-spacer />
              <v-btn
                v-if="$i18n.locale === 'fa'"
                :loading="loading"
                @click="showMessageModal"
                v-status="'historySendMessasge_create'"
                class="btn-send-sms"
              >
                <v-icon>mdi-email-check</v-icon>
                {{ $t("UserHistory.send_message") }}
              </v-btn>
            </v-card-title>
            <v-divider />
            <div class="row">
              <div class="col-md-12 p-5">
                <data-table
                  orderDir="desc"
                  :data="data"
                  :columns="columnTransactions"
                  :translate="tableTranslates"
                  @on-table-props-changed="reloadTable"
                  :footer-props="{
                    'items-per-page-text': $t('UserHistory.table.itemsPerPage'),
                    'page-text': $t('UserHistory.table.pageText'),
                    'prev-text': $t('UserHistory.table.prevText'),
                    'next-text': $t('UserHistory.table.nextText'),
                    'no-data-text': $t('UserHistory.table.noDataText'),
                  }"
                >
                </data-table>
              </div>
            </div>
          </v-container>
        </div>
        <v-dialog
          transition="dialog-bottom-transition"
          v-model="create"
          persistent
          max-width="800"
        >
          <template v-slot:default="create">
            <v-card>
              <v-toolbar color="#b54405" class="font-weight-bold" dark>
                <v-icon>mdi-history</v-icon>
                {{ $t("UserHistory.new_history_dialog_title") }}
                <v-spacer />
                <v-btn
                  small
                  icon
                  rounded
                  @click="canselHistory"
                  class="ml-1 text-hover-danger text-white"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-row class="mt-5">
                  <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                    <v-text-field
                      outlined
                      :label="$t('UserHistory.form.title')"
                      v-model="createHistory.title"
                      dense
                      :error-messages="historyErrors.title"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                    <v-text-field
                      outlined
                      :label="$t('UserHistory.form.status')"
                      v-model="createHistory.status"
                      dense
                      :error-messages="historyErrors.status"
                    ></v-text-field>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                    <date-picker
                      :locale="$i18n.locale === 'ar' ? 'ar' : $i18n.locale"
                      :label="$t('UserHistory.form.current_time')"
                      format="YYYY-MM-DD HH:mm"
                      :min="data.now"
                      type="time"
                      :display-format="
                        $i18n.locale === 'fa'
                          ? 'jYYYY-jMM-jDD HH:mm'
                          : $i18n.locale === 'en' || $i18n.locale === 'en_US'
                          ? 'YYYY-MM-DD HH:mm'
                          : 'jYYYY-jMM-jDD HH:mm'
                      "
                      v-model="createHistory.current_time"
                    ></date-picker>
                    <div v-if="historyErrors.length != 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="historyErrors.current_time"
                        v-for="(des, ind) in historyErrors.current_time"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-container fluid>
                    <v-alert>{{ $t("UserHistory.negotiations") }} :</v-alert>
                    <!-- <ckeditor
                      :editor="editor.editor"
                      v-model="createHistory.description"
                      :config="editor.editorConfig"
                    ></ckeditor>
 -->
                    <suggest-input
                      v-model="createHistory.description"
                      :label="$t('UserHistory.negotiations')"
                      :placeholder="$t('UserHistory.negotiations')"
                    />

                    <div v-if="historyErrors.length != 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="historyErrors.description"
                        v-for="(des, ind) in historyErrors.description"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-container>
                </v-row>
                <v-row>
                  <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                    <date-picker
                      :locale="$i18n.locale === 'ar' ? 'ar' : $i18n.locale"
                      :label="$t('UserHistory.form.next_time')"
                      format="YYYY-MM-DD HH:mm"
                      type="datetime"
                      :min="data.tomorrow"
                      :display-format="
                        $i18n.locale === 'fa'
                          ? 'jYYYY-jMM-jDD HH:mm'
                          : $i18n.locale === 'en' || $i18n.locale === 'en_US'
                          ? 'YYYY-MM-DD HH:mm'
                          : 'jYYYY-jMM-jDD HH:mm'
                      "
                      v-model="next_time"
                    ></date-picker>
                    <div v-if="historyErrors.length != 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="historyErrors.next_time"
                        v-for="(des, ind) in historyErrors.next_time"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-container fluid>
                    <v-alert>{{ $t("UserHistory.follow_up") }} :</v-alert>
                    <suggest-input
                      v-model="createHistory.pursue_text"
                      :label="$t('UserHistory.follow_up')"
                      :placeholder="$t('UserHistory.follow_up')"
                    />

                    <!-- <ckeditor
                      :editor="editor.editor"
                      v-model="createHistory.pursue_text"
                      :config="editor.editorConfig"
                    ></ckeditor> -->
                    <div v-if="historyErrors.length != 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="historyErrors.pursue_text"
                        v-for="(des, ind) in historyErrors.pursue_text"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-container>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn class="btn-cancel" @click="canselHistory">
                  <v-icon>mdi-close-circle</v-icon>
                  {{ $t("UserHistory.cancel") }}
                </v-btn>
                <v-btn
                  class="submit-btn"
                  @click="store"
                  :loading="storeloading"
                  :disabled="storeloading"
                >
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  {{ $t("UserHistory.save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
        <v-dialog v-model="messageModal" persistent max-width="400px">
          <v-card>
            <v-card-title>
              <span class="text-h5">{{
                $t("UserHistory.send_message_dialog_title")
              }}</span>
              <v-spacer />
              <v-btn
                small
                icon
                rounded
                @click="canselMessage"
                class="ml-1 text-danger"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-autocomplete
                      :items="messageCategories.data"
                      item-text="title"
                      v-model="category_id"
                      :loading="loadingCategory"
                      @change="getMessageQuery"
                      item-value="id"
                      clearable
                      outlined
                      dense
                      :label="$t('UserHistory.form.category')"
                    >
                      <template slot="item" slot-scope="{ item }">
                        <div>{{ item.title }}</div>
                      </template>
                      <template slot="append-item">
                        <v-container>
                          <div class="text-center">
                            <v-pagination
                              v-model="page"
                              :length="messageCategories.last_page"
                              :total-visible="2"
                              circle
                            ></v-pagination>
                          </div>
                        </v-container>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    lg12
                    xl12
                    class="p-2"
                    v-if="messages.data"
                  >
                    <v-autocomplete
                      :items="messages.data"
                      dense
                      filled
                      clearable
                      item-text="title"
                      item-value="id"
                      :error-messages="messageError.id"
                      v-model="message"
                      return-object
                      :label="$t('UserHistory.form.message_title')"
                    ></v-autocomplete>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                    <date-picker
                      :locale="$i18n.locale === 'ar' ? 'ar' : $i18n.locale"
                      :label="$t('form.next_time')"
                      :display-format="
                        $i18n.locale === 'fa'
                          ? 'jYYYY-jMM-jDD HH:mm'
                          : $i18n.locale === 'en' || $i18n.locale === 'en_US'
                          ? 'YYYY-MM-DD HH:mm'
                          : 'jYYYY-jMM-jDD HH:mm'
                      "
                      :min="data.tomorrow"
                      type="datetime"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      v-model="next_time"
                    ></date-picker>
                    <div v-if="messageError.length != 0">
                      <p
                        class="mt-2 text-danger font-weight-bold"
                        v-if="messageError.next_time"
                        v-for="(des, ind) in messageError.next_time"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-flex>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn class="btn-cancel" @click="canselMessage">
                {{ $t("UserHistory.cancel") }}
              </v-btn>
              <v-btn class="submit-btn" @click="sendSms">
                {{ $t("UserHistory.send_message") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showDescription" max-width="400px">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                    <v-text-field
                      disabled
                      :label="$t('UserHistory.form.description')"
                    ></v-text-field>
                    <v-textarea
                      outlined
                      :label="$t('UserHistory.form.description')"
                      readonly
                      v-html="description"
                    ></v-textarea>
                    <div v-if="pursueText !== null">
                      <v-text-field
                        disabled
                        :label="$t('UserHistory.form.pursue_text')"
                      ></v-text-field>
                      <v-textarea
                        outlined
                        :label="$t('UserHistory.form.pursue_text')"
                        readonly
                        v-html="pursueText"
                      ></v-textarea>
                    </div>
                  </v-flex>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-app>
</template>

<script>
// import suggestInput from "../../../../../core/plugins/TitleRibbon/components/contacts/SuggestBox/suggestInput.vue";
import suggestInput from "../../../../content/sms/suggestInput/suggestInput.vue";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import HistoryBtn from "@/view/pages/admin/users/actions/HistoryBtn";

export default {
  name: "UserHistory",
  props: ["phone"],
  components: { suggestInput },
  data() {
    return {
      storeloading: false,
      pursueText: null,
      search: null,
      showDescription: false,
      description: null,
      historyErrors: [],
      messageCategories: [],
      page: 1,
      next_time: null,
      messageError: [],
      messageModal: false,
      // editor: {
      //   editor: ClassicEditor,
      //   editorConfig: {
      //     extraPlugins: [CKEditorUploadAdapterPlugin],
      //   },
      // },
      create: false,
      url: "user/history",
      createHistory: {
        status: null,
        phoneNumber: this.phone,
        title: null,
        pursue_text: null,
        description: null,
        current_time: null,
      },
      data: {},
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      loading: false,
      // tablePerPages: [10, 25, 50, 100],
      columnTransactions: [
        {
          name: "id",
          label: this.$t("UserHistory.columns.id"),
          orderable: true,
        },
        {
          name: "title",
          label: this.$t("UserHistory.columns.title"),
          orderable: true,
          searchable: true,
        },
        {
          name: "status",
          label: this.$t("UserHistory.columns.status"),
          orderable: true,
          searchable: true,
        },
        {
          name: "current_time",
          label: this.$t("UserHistory.columns.current_time_date"),
          orderable: true,
          transform: (val) => {
            return this.$options.filters.onlyDate(val.data.current_time);
          },
        },
        {
          label: this.$t("UserHistory.columns.current_time_hour"),
          orderable: true,
          transform: (val) => {
            return this.$options.filters.onlyTime(val.data.current_time);
          },
        },
        {
          name: "next_time",
          label: this.$t("UserHistory.columns.next_time_date"),
          orderable: true,
          transform: (val) => {
            return this.$options.filters.onlyDate(val.data.next_time);
          },
        },
        {
          label: this.$t("UserHistory.columns.next_time_hour"),
          orderable: true,
          transform: (val) => {
            return this.$options.filters.onlyTime(val.data.next_time);
          },
        },
        {
          name: "user_id",
          label: this.$t("UserHistory.columns.user_id"),
          transform: (val) => {
            return val.data.owner.username;
          },
        },
        {
          name: "actions",
          label: this.$t("UserHistory.columns.actions"),
          component: HistoryBtn,
          handler: this.actions,
          event: "action",
        },
      ],
      rules: {},
      messageUrl: "user/messages",
      messages: [],
      message: [],
      categoryUrl: "message/categories",
      query: {
        page: 1,
        search: "",
        length: 5,
      },
      loadingCategory: false,
      category_id: null,
    };
  },
  computed: {
    tableTranslates() {
      return {
        next: this.$t("UserHistory.table.nextText"),
        previous: this.$t("UserHistory.table.prevText"),
        noData: this.$t("UserHistory.table.noDataText"),
        search: this.$t("UserHistory.table.search"),
        itemsPerPage: this.$t("UserHistory.table.itemsPerPage"),
      };
    },
  },
  watch: {
    page(val) {
      this.query.page = val;
      this.getMessageCategories(this.categoryUrl, this.query);
    },
    showDescription(val) {
      if (val === false) this.pursueText = null;
    },
    "$i18n.locale": {
      handler() {
        // Update columnTransactions in response to locale changes
        this.columnTransactions = [
          {
            name: "id",
            label: this.$t("UserHistory.columns.id"),
            orderable: true,
          },
          {
            name: "title",
            label: this.$t("UserHistory.columns.title"),
            orderable: true,
            searchable: true,
          },
          {
            name: "status",
            label: this.$t("UserHistory.columns.status"),
            orderable: true,
            searchable: true,
          },
          {
            name: "current_time",
            label: this.$t("UserHistory.columns.current_time_date"),
            orderable: true,
            transform: (val) => {
              return this.$options.filters.onlyDate(val.data.current_time);
            },
          },
          {
            label: this.$t("UserHistory.columns.current_time_hour"),
            orderable: true,
            transform: (val) => {
              return this.$options.filters.onlyTime(val.data.current_time);
            },
          },
          {
            name: "next_time",
            label: this.$t("UserHistory.columns.next_time_date"),
            orderable: true,
            transform: (val) => {
              return this.$options.filters.onlyDate(val.data.next_time);
            },
          },
          {
            label: this.$t("UserHistory.columns.next_time_hour"),
            orderable: true,
            transform: (val) => {
              return this.$options.filters.onlyTime(val.data.next_time);
            },
          },
          {
            name: "user_id",
            label: this.$t("UserHistory.columns.user_id"),
            transform: (val) => {
              return val.data.owner.username;
            },
          },
          {
            name: "actions",
            label: this.$t("UserHistory.columns.actions"),
            component: HistoryBtn,
            handler: this.actions,
            event: "action",
          },
        ];
        this.reloadTable(this.tableProps);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getMessageQuery() {
      if (this.category_id !== null) return this.getMessage(this.category_id);
      if (this.search !== null) return (this.messages = []);
    },
    getMessageCategories(url = this.categoryUrl, query = this.query) {
      if (query.search === null) this.$modal.showLoading();
      this.loadingCategory = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.loadingCategory = false;
          this.messageCategories = data;
        })
        .catch(() => {
          this.loadingCategory = false;
          this.$modal.hideLoading();
        });
    },
    reloadTable(tableProps) {
      this.getHistory(this.url, tableProps);
    },
    sendSms() {
      this.$modal.showLoading();
      this.requestApiPost("user/message", {
        phone_number: this.phone,
        title: this.message.title,
        message_id: this.message.id,
        description: this.message.description,
        next_time: this.next_time,
        notif_id: this.$route.query.notifId,
      })
        .then(() => {
          this.$toast.success(this.$t("UserHistory.success_message"));
          this.canselMessage();
          this.getHistory();
          this.$modal.hideLoading();
        })
        .catch(({ response }) => {
          this.messageError = response.data.errors;
          this.$modal.hideLoading();
        });
    },
    getHistory(url = this.url, query = this.tableProps) {
      this.requestApiGet(`${url}/${this.phone}`, query)
        .then(({ data }) => {
          this.data = data;
          this.next_time = data.tomorrow;
        })
        .catch(() => {});
    },
    getMessage(query) {
      this.requestApiGet(`user/messages/${query}`)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.messages = data;
        })
        .catch(() => {
          this.$modal.hideLoading();
        });
    },
    async showMessageModal() {
      await this.getMessageCategories();
      this.messageModal = true;
    },
    store() {
      if (this.storeloading) return;
      this.storeloading = true;

      this.$modal.showLoading();
      this.requestApiPost(`user/history/${this.phone}`, {
        ...this.createHistory,
        next_time: this.next_time,
        notif_id: this.$route.query.notifId,
      })
        .then(() => {
          this.$modal.hideLoading();
          this.canselHistory();
          this.$toast.success(this.$t("UserHistory.success_history"));
          this.getHistory();
          this.storeloading = false;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.historyErrors = response.data.errors;
          this.storeloading = false;
        });
    },
    canselHistory() {
      this.create = false;
      this.createHistory.title = null;
      this.createHistory.description = null;
      this.createHistory.status = null;
      this.createHistory.current_time = null;
      this.next_time = this.data.tomorrow;
      this.historyErrors = [];
    },
    canselMessage() {
      this.messageModal = false;
      this.next_time = this.data.tomorrow;
      this.message = [];
    },
    actions(data, type) {
      this[type](data);
    },
    history(data) {
      this.showDescription = true;
      this.description = data.description;
      this.pursueText = data.pursue_text !== null ? data.pursue_text : null;
    },
    messageFun(data) {
      this.showDescription = true;
      this.description = data.description;
    },
  },
  created() {
    this.getHistory(this.url);
  },
};
</script>

<style scoped></style>
